const REQUEST_ITEMS_STATS = "REQUEST_ITEMS_STATS";
const RECEIVE_ITEMS_STATS = "RECEIVE_ITEMS_STATS";

export default {
    REQUEST_ITEMS_STATS, 
    RECEIVE_ITEMS_STATS, 
}